import {baseUrl} from './env';
import {getStore} from './mUtils';
import axios from 'axios';

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
    let TOKEN = getStore('NameAppUserToken');
    type = type.toUpperCase();
    url = baseUrl + url;
    let requestConfig = {};


    if (method == 'noauth' || method == 'fetch') {
        requestConfig = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
    } else {
        requestConfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': TOKEN,

            }
        }
    }

    let dataStr = ''; //数据拼接字符串
    switch (type) {
        case "GET":

            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&';
            })
            if (dataStr !== '') {
                dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
                url = url + '?' + dataStr;
            }
            try {

                const res = await axios.get(url, requestConfig);
                return Promise.resolve(res.data);

            } catch (error) {
                return Promise.reject(error.response.data);
            }
            break;

        case "POST":
            try {
                const res = await axios.post(url, data, requestConfig);
                return Promise.resolve(res.data);
            } catch (error) {
                return Promise.reject(error.response.data);
            }
            break;

      case "POSTFILE":
        try {
          requestConfig = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': TOKEN,

            }
          }
          const res = await axios.post(url, data, requestConfig);
          return Promise.resolve(res.data);
        } catch (error) {
          return Promise.reject(error.response.data);
        }
        break;
        case "PUT":
            try {
                const res = await axios.put(url, data, requestConfig);
                return Promise.resolve(res.data);
            } catch (error) {
                return Promise.reject(error.response.data);

            }
            break;
        case "DELETE":

            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&';
            })
            if (dataStr !== '') {
                dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
                url = url + '?' + dataStr;
            }
            try {

                const res = await axios.delete(url, requestConfig);

                return Promise.resolve(res.data);
            } catch (error) {
                return Promise.reject(error.response.data);
            }
            break;
    }
}

